import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useTagHttp } from '@/core/api/tags'
import { Tag, TagPayload } from '@/core/models/tag'

export type TagCollection = {
    data: Array<Tag>,
    meta?: MetaPayload,
    links?: any
}

const state: TagCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const tagCollection: Module<TagCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: TagCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: TagPayload) => {
                state.data.push(new Tag(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useTagHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: TagCollection): TagCollection => {
            return state
        }
    }
}
